<template>
  <div>
    <p class="form_label_head">{{ $t("trackPay.contractsEditModal.productGroup") }}</p>
    <div class="flex flex_between">
      <md-field :class="[{ 'md-error': error }]">
        <label>{{ $t("trackPay.contractsEditModal.productGroup") }}</label>
        <TbSelect
            v-model="moduleValue"
            @md-selected="onSelect"
            :search-allow="true"
            :search-debounce="400"
            :search-min-length="2"
            :options="options"
            options-value-field="id"
            options-display-field="title"
            :required="required"
            :no-entries-text="$t('common.select.searchRequired')"
            :disabled="disabled"
        />
        <span v-if="error" class="validation-error">{{ error }}</span>
      </md-field>
    </div>
  </div>
</template>
<script>
import {trackPayApi} from "../../../common/api/trackPayApi";

export default {
  props: {
    error: {type: Boolean, default: ""},
    labelText: {type: String, default: "value"},
    value: {type: [Object, String], default: ""},
    required: {type: Boolean, default: false},
    disabled: {type: Boolean, default: false},
  },
  data() {
    return {
      moduleValue: "",
      options: [],
    };
  },
  watch: {
    value() {
      this.moduleValue = this.value;
    },
  },
  created() {
    trackPayApi.seller.getProductGroups()
        .then((res) => {
          this.options = res;
          this.moduleValue = this.value;
        })
        .catch(this.toast);
  },
  methods: {
    onSelect() {
      let filterElement = this.options.filter(o => o.id === this.moduleValue)[0];
      this.$emit("input", {id: this.moduleValue, title: filterElement ? filterElement.title : ""});
    },
  },
};
</script>
